/**
 * Locale enum - not trimmed
 */
export enum Locale {
  ENGLISH_US = 'en-US',
  ENGLISH_CA = 'en-CA',
  FRENCH_CA = 'fr-CA',
  SPANISH_US = 'es-US',
}
